<template>
  <div class="importance-container">
    <el-rate
      :model-value="value"
      size="small"
      :colors="['#129B91', '#129B91', '#129B91']"
      @change="handleChange"
      :disabled="disabled"
    />
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from "vue";
const emits = defineEmits(["update:value", "change"]);
const props = defineProps({
  value: {
    type: Number,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
const handleChange = (value) => {
  emits("update:value", value);
  emits("change", value);
};
</script>

<style lang="scss" scoped></style>
